import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { CartAddEvent, ThemeEvents } from '@theme/events';

/**
 * Wrapper component for quick buy buttons that refreshes availability
 * state after cart updates via the Section Rendering API.
 */
class QuickBuyFormComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  #handleCartUpdate = (event) => {
    if (!(event instanceof CartAddEvent)) return;

    const sectionId = this.dataset.sectionId;
    if (sectionId) {
      sectionRenderer.renderSection(sectionId, { cache: false });
    }
  };
}

if (!customElements.get('quick-buy-form-component')) {
  customElements.define('quick-buy-form-component', QuickBuyFormComponent);
}
